// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"db14cd74","239":"05d1037d","453":"926f0775","455":"d9fd465d","646":"a8783175","977":"d35724d6"}[chunkId] + ".chunk.js";
};